import {Title} from "#app/interface/cabinet/header/Dropdown/styles";
import Dropdown from "#app/interface/cabinet/header/Dropdown/Dropdown";
import React from "react";
import {routes} from "#app/constants/routes";

const ConfigDropdown = ({ i18n, handleMenu, url }) => {
  const condition5 = url === routes.config.index;

  return (
    <Dropdown
      id="dropdown-config"
      width="auto"
      containerId="dropdown-config-container"
      links={[]}
    >
      <Title
        id="accounting-tab-4"
        className={condition5 ? 'active' : ''}
        onClick={(e) => handleMenu(e, routes.config.index)}
      >
        {i18n.menu.config}
      </Title>
    </Dropdown>
  );
};

export default ConfigDropdown;